import React, { Component } from "react";
import CKEditor from "ckeditor4-react";
import * as api from "./../../api/api";
import * as Moment from "moment";
import SimpleReactValidator from "simple-react-validator";

class AddPost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category_id: "",
      title: "",
      details: "",
      url: "",
      image: [],
      publication_type_id: "",
      key_word: "",
      is_active: "0",
      category: "",
      type: "",
      sponsor: "",
      sponsor_id: this.props.id,
      publish_date: "",
      success: false,
      fail: false,
      message: "",
      currentDate: Moment(new Date()).format("YYYY-MM-DDTHH:mm"),
      imgMsg: "",
      isPaid: false,
    };
    // console.log("date", this.state.currentDate);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.validator = new SimpleReactValidator();
  }

  componentDidMount() {
    this.categoryApi();
    this.typeApi();
    // this.checkPaymentApi();
  }

  checkPaymentApi = async () => {
    try {
      let response = await api.checkPayment();
      if (response == 1) {
        this.setState({
          isPaid: true,
        });
      }
    } catch (e) {}
  };

  categoryApi = async () => {
    try {
      let response = await api.category();
      this.setState({
        category: response.data,
      });
    } catch (e) {}
  };

  typeApi = async () => {
    try {
      let response = await api.type();
      this.setState({
        type: response.data,
      });
    } catch (e) {}
  };

  onChange(e) {
    const { name, value } = e.target;
    //
    this.validator.showMessageFor(name);
    this.setState({
      [name]: value,
    });
  }

  handleSubmit = async () => {
    const {
      category_id,
      title,
      sponsor_id,
      details,
      url,
      image,
      key_word,
      publication_type_id,
      is_active,
      publish_date,
    } = this.state;

    if (this.validator.allValid()) {
      try {
        let requestObj = new FormData();
        for (var i = 0; i < image.length; i++) {
          requestObj.append("image[" + i + "]", image[i]);
        }
        requestObj.append("category_id", "1");
        requestObj.append("sponser_id", sponsor_id);
        requestObj.append("title", title);
        requestObj.append("details", details);
        requestObj.append("url", url);
        requestObj.append("key_word", key_word);
        requestObj.append("publication_type_id", "1");
        requestObj.append("is_active", is_active);
        requestObj.append(
          "publish_date",
          this.isPaid ? publish_date : Moment(new Date()).format("YYYY-MM-DD")
        );

        const response = await api.uploadNews(requestObj);
        this.setState({
          success: true,
          fail: false,
          message: response.data.message,
        });
      } catch (e) {
        this.setState({
          fail: true,
          success: false,
        });
      }
    } else {
      this.validator.showMessages();
      this.setState({
        fail: true,
        success: false,
      });
    }
  };

  handleFileUpload(e) {
    const img = e.target.files;
    this.readImageFile(img[0]);
    Object.keys(img).map((i) => {
      if (img[0].name.match(/\.(jpg|jpeg)$/) && img[i].size < 500000) {
        this.setState({
          image: [...this.state.image, ...e.target.files],
          imgMsg: false,
        });
      } else {
        this.setState({
          imgMsg: true,
        });
        return;
      }
    });

    this.setState({
      image: [...this.state.image, ...e.target.files],
    });
  }

  readImageFile = (file) => {
    var reader = new FileReader(file); // CREATE AN NEW INSTANCE.

    reader.onload = (e) => {
      var img = new Image();
      img.src = e.target.result;

      img.onload = function () {
        var w = this.width;
        var h = this.height;
      };
    };
  };

  handleEditor = (e) => {
    this.setState({
      details: e.editor.getData(),
    });
    console.log("world");
  };

  render() {
    return (
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="row">
            <div className="col-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title"> Add Posts </h4>
                  <p className="card-description">
                    <b>
                      If you post something you don't like, it cannot be edited.
                      Please post a duplicate, corrected story (including
                      photos), and notify Tim Kern 863-651-6095 or
                      info@timkern.com to remove the mistaken story.
                      (Duplicates, when discovered by the Publisher, will be
                      removed, leaving the newest in place.)
                    </b>
                  </p>

                  <form className="forms-sample" encType="multipart/form-data">
                    <div className="row"></div>
                    <div className="row">
                      <div className="form-group col-lg-6">
                        <label for="exampleInputName1">
                          News Title<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputName1"
                          placeholder="News Title"
                          name="title"
                          onChange={this.onChange}
                        />
                        {this.validator.message(
                          "title",
                          this.state.title,
                          "required",
                          { className: "text-danger" }
                        )}
                      </div>

                      <div className="form-group col-lg-6">
                        <label for="exampleInputEmail3">
                          Website<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Website"
                          name="url"
                          onChange={this.onChange}
                        />
                        {this.validator.message(
                          "website",
                          this.state.url,
                          "required|url",
                          { className: "text-danger" }
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="form-group col-lg-6">
                        <label for="exampleInputEmail3">
                          Key Word<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputEmail3"
                          placeholder="Key Word"
                          name="key_word"
                          onChange={this.onChange}
                        />
                        {this.validator.message(
                          "key_word",
                          this.state.key_word,
                          "required",
                          { className: "text-danger" }
                        )}
                      </div>
                      <div className="form-group col-lg-6">
                        <label for="exampleInputEmail3">Publish Date</label>

                        <input
                          min={this.state.currentDate}
                          value={this.state.currentDate}
                          id="date"
                          type="datetime-local"
                          className="form-control"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="publish_date"
                          onChange={this.onChange}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="form-group col-lg-12">
                        <label for="exampleInputEmail3">
                          Details<span className="text-danger">*</span>
                        </label>
                        {/* <textarea type="text-area" className="form-control" id="exampleInputEmail3" placeholder="Details" name="details" onChange={this.onChange}/> */}

                        {this.validator.message(
                          "Description",
                          this.state.details,
                          "required",
                          { className: "text-danger" }
                        )}
                      </div>
                    </div>

                    <div className="form-group">
                      <label>
                        File upload{" "}
                        <span className="font-italic">
                          (upload only jpeg/jpg images and size should be less
                          then 500kb)
                        </span>
                      </label>

                      <div className="input-group col-xs-12">
                        <input
                          onChange={this.handleFileUpload}
                          type="file"
                          multiple
                          className="form-control file-upload-info"
                          placeholder="Upload Image"
                        />
                        {/* <span className="input-group-append">
                          <button
                            className="file-upload-browse btn btn-gradient-primary"
                            type="button"
                            style={{ color: "white" }}
                          >
                            Upload
                          </button>
                        </span> */}
                      </div>
                      {this.state.imgMsg ? (
                        <p className="text-danger">
                          upload jpeg/jpg images and size should be less then
                          500kb
                        </p>
                      ) : (
                        ""
                      )}
                      <span className="notePoint font-italic">
                        <b>Note :</b> press ctrl for upload multiple images
                      </span>
                    </div>
                  </form>
                  <button
                    onClick={this.handleSubmit}
                    className="btn btn-gradient-primary mr-2"
                    style={{ color: "white" }}
                  >
                    Save
                  </button>
                  {/* <button className="btn btn-light">Cancel</button> */}

                  {/* {this.state.success ?  */}
                  {this.state.success ? (
                    <div className="pt-2 text-success">
                      Post added Successfully
                    </div>
                  ) : null}

                  {this.state.fail ? (
                    <div className="pt-2 text-danger">
                      Please fill all the required data
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddPost;
